import React, { useMemo } from 'react'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useApiFormNodeMove } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'

import { IconMove } from '../../../../../../shared/icon/icon'
import { FolderMenu } from '../../common/menu/node-actions'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'

export const NodeCategoryMove = ({ parentURL, nodeID, rootName, useApiListCategory, useApiForm, buildPathFn, dataContext, section }) => {
  const history = useHistory()

  const apiForm = useApiForm()
  const apiFormNodeMove = useApiFormNodeMove()
  const apiListCategory = useApiListCategory()

  const title = useMemo(() => apiForm.form.name, [apiForm.form])

  const handleMatch = async () => await apiForm.get(nodeID)

  // A refused move is shown by FormSimple (the layout's alert, with the
  // request's reference) and the page stays. It used to be caught here and
  // handed to an alert as exp.error, which api-new's failure doesn't have:
  // the alert came up empty, and a network failure threw inside the catch.
  const handleSubmit = async data => {
    if (data.parentID === -1) {
      data.parentID = null
    }

    await apiFormNodeMove.put(data.nodeID, data)

    await dataContext.reload()

    const nodes = await apiListCategory.get(`ancestors/${data.nodeID}`)
    const path = buildPathFn(nodes, data.nodeID)
    history.replace(path)
  }

  const HeaderMenu = () => <FolderMenu place="header" url={parentURL} nodeID={nodeID} section={section} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconMove} text="Move" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={nodeID} required />
            <FormSimpleCategorySelectFilter useApiListCategory={useApiListCategory} name="parentID" label="category" rootName={rootName} required />
            <FormSimpleSubmitEdit text="move" backURL={parentURL} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
